







































// vue
import { ref, defineComponent, onMounted } from '@vue/composition-api';
import * as turf from '@turf/turf';

// primevue
import Slider from 'primevue/slider';
import ProgressSpinner from 'primevue/progressspinner';
import InputNumber from 'primevue/inputnumber';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';

export default defineComponent({
    components: {
        Slider,
        ProgressSpinner,
        InputNumber,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        mapbox: {
            type: Object,
            default: null,
        },
        value: {
            type: Number,
            default: 0,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, { emit }) {
        // hooks
        const {
            addGeoRecordExtrusion,
            updateGeoRecordExtrusion,
            removeGeoRecordExtrusion,
            createGeoRecordExtrusion,
            refreshCreatedGeoRecordExtrusion,
            removeCreatedGeoRecordExtrusion,
        } = useGeoRecord();

        const localHeight = ref<any>(props.geoRecord.height);
        const geoRecordValue = ref<any>(
            JSON.parse(JSON.stringify(props.geoRecord)),
        );

        // methods
        const changeExtrusion = () => {
            if (props.geoRecord.height > 0) {
                updateExtrusion();
                const source = props.mapbox.map.getSource(
                    'geo-records-extrusion',
                );
                const features = source._data.features;
                if (props.geoRecord.id === undefined) {
                    const featureIndex = features.findIndex(
                        (x) => x.id === 'temp-extrusion',
                    );
                    if (featureIndex > -1) {
                        refreshCreatedGeoRecordExtrusion(
                            props.mapbox.map,
                            geoRecordValue.value,
                        );
                    } else {
                        createGeoRecordExtrusion(
                            props.mapbox.map,
                            geoRecordValue.value,
                        );
                    }
                } else {
                    const featureIndex = features.findIndex(
                        (x) => x.id === props.geoRecord.id,
                    );

                    if (featureIndex > -1) {
                        updateGeoRecordExtrusion(
                            props.mapbox.map,
                            geoRecordValue.value,
                        );
                    } else {
                        addGeoRecordExtrusion(
                            props.mapbox.map,
                            geoRecordValue.value,
                        );
                    }
                }
            } else {
                removeGeoRecordExtrusion(
                    props.mapbox.map,
                    geoRecordValue.value,
                );
                removeCreatedGeoRecordExtrusion(props.mapbox.map);
            }
        };

        const updateExtrusion = () => {
            let selectedGeom = props.geoRecord.geometry;
            if (selectedGeom.type === 'LineString') {
                const lineString = turf.lineString(selectedGeom.coordinates);
                const buffered = turf.buffer(lineString, 0.0000009, {
                    units: 'degrees',
                });
                geoRecordValue.value.geometry = buffered.geometry;
                geoRecordValue.value.isFill = true;
            }
            if (selectedGeom.type == 'Point') {
                const point = turf.point(selectedGeom.coordinates);
                const buffered = turf.circle(point, 0.0000009, {
                    units: 'degrees',
                });
                geoRecordValue.value.geometry = buffered.geometry;
                geoRecordValue.value.isFill = true;
            }
        };

        const updateExternalHeight = (v: any) => {
            const updatedGeoRecordValue = props.handleGeoRecordPropertyUpdate({
                height: v,
            });
            localHeight.value = updatedGeoRecordValue.height;
            geoRecordValue.value.height = updatedGeoRecordValue.height;
            emit('input', v);
            changeExtrusion();
        };

        // lifecycle
        onMounted(() => {
            changeExtrusion();
        });

        return {
            changeExtrusion,
            localHeight,
            updateExternalHeight,
        };
    },
});
